import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import { LeverFormVM } from 'front-office/view-models/lever/lever-form';
import LeverCheckboxes from './form';

const LeverAnprComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<LeverFormVM>();

  const onChange = useCallback(
    (identifier) => {
      const isSelected =
        formContext.values.lever?.key.codiceDocumento === identifier.key.codiceDocumento;

      formContext.setFieldValue('lever', isSelected ? undefined : identifier);

      if (!formContext.values.certificateInternOnly && identifier.dettaglioModalitaRilascio) {
        formContext.setFieldValue(
          'modality',
          isSelected
            ? undefined
            : {
                id: identifier.dettaglioModalitaRilascio.key.codiceModalitaRilascio,
                value: identifier.dettaglioModalitaRilascio.descrizione,
                amountTaxStamp: identifier.dettaglioModalitaRilascio.importoImpostaBollo
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoImpostaBollo)
                  : 0,
                amountRightsSecretariat: identifier.dettaglioModalitaRilascio
                  .importoDirittiSegreteria
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiSegreteria)
                  : 0,
                amountRightsCivilState: identifier.dettaglioModalitaRilascio
                  .importoDirittiStatoCivile
                  ? Number.parseFloat(
                      identifier.dettaglioModalitaRilascio.importoDirittiStatoCivile
                    )
                  : 0,
                amountFixedRights: identifier.dettaglioModalitaRilascio.importoDirittiFissi
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiFissi)
                  : 0,
                amountExpenses: identifier.dettaglioModalitaRilascio.importoSpese
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoSpese)
                  : 0,
                codeExemptionAnpr: identifier.dettaglioModalitaRilascio.codiceEsenzioneAnpr,
                registryType: identifier.dettaglioModalitaRilascio.tipoRegistro,
                descrizioneModalitaStampa:
                  identifier.dettaglioModalitaRilascio.descrizioneModalitaStampa,
                disabled: true,
              }
        );
      }
    },
    [formContext.setFieldValue, formContext.values.lever]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-lever-anpr-content"
        id="panel-lever-anpr-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Certificati Leva</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <LeverCheckboxes
            onChange={onChange}
            values={formContext.values.lever}
            isAire={
              formContext.values.accountholder?.isAire ||
              (formContext.values.isAire && formContext.values.accountholder?.sameApplicant)
                ? '1'
                : '0'
            }
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

LeverAnprComponent.displayName = 'Accordion historical anpr component';

const LeverAnpr = memo(LeverAnprComponent);

export default LeverAnpr;
